import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { verifyPaymentReturn } from "../lib/paymentsApi";

export function usePaymentVerification(expectedOutcome) {
    const [searchParams] = useSearchParams();
    const [state, setState] = useState({
        loading: true,
        data: null,
        error: null,
    });

    useEffect(() => {
        let cancelled = false;

        const run = async () => {
            const sessionId = searchParams.get("payments_session_id");
            const reference =
                searchParams.get("udf5") || searchParams.get("txnid");
            const paymentStatus =
                searchParams.get("payment_status") || searchParams.get("status");
            const sessionStatus = searchParams.get("payment_session_status");
            const provider = searchParams.get("provider");
            if (
                !sessionId &&
                !reference &&
                !paymentStatus &&
                !sessionStatus &&
                !provider
            ) {
                setState({
                    loading: false,
                    data: null,
                    error: "Missing payment details.",
                });
                return;
            }

            try {
                const data = await verifyPaymentReturn(
                    Object.fromEntries(searchParams.entries()),
                );
                if (!cancelled) {
                    setState({ loading: false, data, error: null });
                }
            } catch (err) {
                if (!cancelled) {
                    setState({
                        loading: false,
                        data: null,
                        error: err.message ?? "Could not verify payment.",
                    });
                }
            }
        };

        run();
        return () => {
            cancelled = true;
        };
    }, [searchParams]);

    const succeeded =
        state.data?.verified &&
        (state.data?.outcome === "success" ||
            state.data?.payment_session_status === "succeeded" ||
            state.data?.payment_status === "succeeded" ||
            state.data?.payment_status === "success" ||
            state.data?.status === "success");

    const failed =
        state.data?.outcome === "failure" ||
        state.data?.payment_session_status === "failed" ||
        state.data?.payment_status === "failed" ||
        state.data?.payment_status === "failure" ||
        state.data?.status === "failure" ||
        expectedOutcome === "failure";

    return { ...state, succeeded, failed };
}
